<template>
  <comHeader></comHeader>
        <!-- inner banner -->
    <div class="inner-banner">
        <section class="w3l-breadcrumb">
            <div class="container">
                <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">关于我们</h4>
                <ul class="breadcrumbs-custom-path">
                    <li><a href="/">主页</a></li>
                    <li class="active"><span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>关于我们</li>
                </ul>
            </div>
        </section>
    </div>
    <!-- //inner banner -->

    <section class="w3l-about-2 py-5">
        <div class="container py-md-5 py-4">
            <div class="row align-items-center justify-content-between ">
                <!-- col-lg-6 about-2-secs-left pr-lg-5 -->
                <div class="about-2-secs-left pr-lg-5">
                    <div class="about-logo">
                        <img src="@/assets/logo.png" style="width:100%;height:100%" alt="Sunray mascota Logo"> 
                    </div>
                    <h3 class="title-style mb-sm-3 mb-2">品牌故事</h3>
                    <p>每一只宠物，都是家庭的一员。</p>
                    <p>但在全球，每年都有超过数千万只宠物走失，其中大多数无法顺利回家，仅仅因为它们“没有身份”。</p>
                    <p>我们团队中的几位成员曾亲身经历宠物走丢的焦虑与无助，这种体验促使我们思考：</p>
                    <p>如果宠物也拥有数字身份，它们的世界会不会更安全？</p>
                    <p>于是，我们创立了这家公司—— 让“宠物有ID，就有归途”。</p>
                    <p>结合我们在NFC、二维码、互联网等领域多年的技术积累，我们打造出一整套宠物身份识别与找回系统，不仅帮助主人快速找回宠物，也推动宠物行业迈向更智能、安全、可持续的未来。
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">品牌愿景</h3>
                    <p>
                        让每一只宠物都拥有数字身份，回家的路不再遥远。
                        我们希望构建一个全球互联的宠物身份网络，
                        让宠物拥有被识别、被尊重、被守护的权利，
                        也让人类与它们的关系更加信任、透明、有温度。


                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">品牌使命</h3>
                    <p>
                        通过技术，为宠物提供可靠的身份识别与安全保障。
                        为宠物主人提供高效、安心的找回解决方案。
                        为合作伙伴输出稳定、安全、可拓展的宠物ID系统解决方案。
                        推动宠物行业数字化转型，提升行业标准和用户体验。
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">品牌价值观</h3>
                    <p>
                        安全——宠物数据加密管理，隐私可控，丢失可快速响应找回。
                        信任——构建宠物与主人之间、品牌与用户之间的双向信任机制。
                        温度——关注每一只宠物的生命旅程，把冰冷技术变成温暖守护。
                        开放协作——与全球品牌、平台、机构协同合作，推动生态共建。
                        可持续发展——打造长期、可迭代的产品体系，支持全球化部署与发展。
                    </p>
                </div>
            </div>
        </div>
    </section>
  </template>
  
  <script>
  import comHeader from '../components/comHeader.vue';

  export default {
    name: 'appAbout',
    components:{
      comHeader
    }
  }
  </script>
  
  <style>
  /* 可添加样式 */
  .title{
    margin-top: 40px;
  }
  .flex-direction{
    flex-direction:column
  }
  .about-logo {
      float: right;
      margin: 15px 0 20px 20px;
      width: 200px;
    }
  </style>